import React from 'react';
import ReactDOM from 'react-dom';
import AppRouting from './components/Router';
import './styles/index.css';

ReactDOM.render(<AppRouting />, document.getElementById('root'));
